// extracted by mini-css-extract-plugin
module.exports = {"lx_list":"lx_list-y-SSqAKP clearfix"};